<template>
<div class="set-coordinates-example">
  <Cropper
    :mouseMove="false"
    :touchMove="true"
    :touchResize="true"
    :wheelResize="false"
    id="pageImgOne"
    :ref="'cropper' + id"
	  class="coodinates-cropper"
    style="width: auto; height: 100%; z-index: 1000"
    :src="img"
    @change="updateSize"
  >
    
  </Cropper>
  <div class="buttons">
      <div class="button" :title="literal['CROPPER']['ALTURA']" @click="resize(1, 2)">
        <i class="fa fa-arrows-alt-v"></i>
      </div>
      <div class="button" :title="literal['CROPPER']['ANCHO']" @click="resize(2, 1)">
        <i class="fa fa-arrows-alt-h"></i>
      </div>
      <div class="button" :title="literal['CROPPER']['CAMBIAR']" @click="resize(0.5, 0.5)">
        <i class="fa fa-compress-arrows-alt"></i>
      </div>
      <div class="button" :title="literal['CROPPER']['MAXIMIZAR']" @click="maximize()">
        <i class="fas fa-expand"></i>
      </div>
      <div class="button" :title="literal['CROPPER']['DESCARGAR']" @click="uploadImage()">
        <i class="fa fa-cloud-download-alt"></i>
      </div>
    </div>
  </div>
</template>

<script>
//Mas informacion en https://github.com/Norserium/vue-advanced-cropper
import { Cropper } from "vue-advanced-cropper";

export default {
  name: "Main",
  components: {
    Cropper,
  },
  data() {
    return {
      size: {
        width: null,
        height: null,
      },
    };
  },
  props: ["img", "literal", "id"],
  methods: {
    uploadImage(event) {
				const { canvas } = this.$refs['cropper' + this.id].getResult("image/jpeg");
				if (canvas) {
          var link = document.createElement('a');
          link.href = canvas.toDataURL();
          link.download = "crop";
          link.click();
				}
			},
    updateSize({ coordinates }) {
      this.size.width = Math.round(coordinates.width);
      this.size.height = Math.round(coordinates.height);
    },
    resize(width = 1, height = 1) {
      let startCoordinates;
      this.$refs['cropper' + this.id].setCoordinates([
        (coordinates, imageSize) => {
          startCoordinates = coordinates;
          return {
            width: coordinates.width * width,
            height: coordinates.height * height,
          };
        },
        (coordinates, imageSize) => ({
          left:
            startCoordinates.left +
            (startCoordinates.width - coordinates.width) / 2,
          top:
            startCoordinates.top +
            (startCoordinates.height - coordinates.height) / 2,
        }),
      ]);
    },
    center() {
      this.$refs['cropper' + this.id].setCoordinates((coordinates, imageSize) => ({
        left: imageSize.width / 2 - coordinates.width / 2,
        top: imageSize.height / 2 - coordinates.height / 2,
      }));
    },
    maximize() {
      // const cropper = this.$refs['cropper' + this.id]
      const center = {
        left: this.$refs['cropper' + this.id].coordinates.left + this.$refs['cropper' + this.id].coordinates.width / 2,
        top: this.$refs['cropper' + this.id].coordinates.top + this.$refs['cropper' + this.id].coordinates.height / 2,
      };
      this.$refs['cropper' + this.id].setCoordinates([
        (coordinates, imageSize) => ({
          width: imageSize.width,
          height: imageSize.height,
        }),
        (coordinates, imageSize) => ({
          left: center.left - coordinates.width / 2,
          top: center.top - coordinates.height / 2,
        }),
      ]);
    },
  },
};
</script>

<style lang="scss">
.set-coordinates-example {
  display: flex;
  justify-content: center;
	user-select: none;
  width: auto; height: 100%; z-index: 1000;
	.coodinates-cropper {
		min-height: 400px;
		background: black;
	}
	.size-info {
		color: white;
		position: absolute;
		font-size: 10px;
		right: 10px;
		bottom: 10px;
		opacity: 0.5;
    z-index: 1001;
	}
	.button {
		background: rgba(black, 0.4);
		display: flex;
		align-items: center;
		justify-content: center;
		height: 42px;
		width: 42px;
		margin-bottom: 10px;
		cursor: pointer;
		transition: background 0.5s;
		&:hover {
			background: black;
		}
	}
	.buttons {
    z-index: 1001;
		position: absolute;
		left: 10px;
		top: 50%;
		transform: translateY(-50%);
    color: white;
	}
}
</style>
